import React from 'react'
import Main from './Main'
import Sidebar from './Sidebar'

function Fields(props) {
  return (
    <div className="questionnaire-request-interstitial-field-container">
      <Main initialAttachments={props.initialAttachments} />
      <Sidebar />
    </div>
  )
}

export default Fields
